<template>
  <div>
    <b-form-group
      label="Sektör"
      label-for="id_sectors"
    >
      <validation-provider
        #default="{ errors }"
        name="Sektör"
        rules="required"
      >
        <v-select
          v-model="dataItem.id_sectors"
          :options="dataListSector"
          label="title"
          :reduce="item => item.id"
          placeholder="Sektör Bilgisi"
          @input="getDataListReferenceTypes()"
        ><!-- @input : burası olay dinleyicisi olarak tanımlandı yani burada değişiklik olduğunda ilgili fonk çağırılması sağlandı  -->
          <template v-slot:option="option">
            <div>
              {{ option.title }}
            </div>

          </template>

        </v-select>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
    <b-form-group
      label="Referans Tipi"
      label-for="id_reference_types"
    >
      <validation-provider
        #default="{ errors }"
        name="Referans Tipi"
        rules="required"
      >
        <v-select
          v-model="dataItem.id_reference_types"
          :options="dataListReferenceTypes"
          label="title"
          :reduce="item => item.id"
          placeholder="Referans Bilgisi"
        >
          <template v-slot:option="option">
            <div>
              {{ option.title }}
            </div>

          </template>

        </v-select>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </div>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'Sector',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      items: [],
      required,
    }
  },
  computed: {
    dataListSector() {
      return this.$store.getters['sectors/dataList']
    },
    dataItem() {
      return this.$store.getters['references/dataItem']
    },
    dataListReferenceTypes() {
      return this.$store.getters['references_types/dataList']
    },

  },
  created() {
    localize('tr')
    this.getDataListSectors()
  },
  methods: {
    getDataListSectors() {
      this.$store.dispatch('sectors/getDataList', {
        select: [
          'sectors.id AS id',
          'sectors.title AS title',
        ],

      })
    },
    getDataListReferenceTypes() {
      this.dataItem.id_reference_types = null
      this.$store.dispatch('references_types/getDataList', {
        select: [
          'references_types.id AS id',
          'references_types.title AS title',
        ],
        where: {
          'references_types.id_sectors =': this.dataItem.id_sectors, // Seçili sektöre göre gruplama yapılacak
        },
      })
    },
  },
}
</script>
